module.exports = __webpack_public_path__ + "img/expressBg.99fc476e.jpg";